<pagination-controls
  class="custom-pagination"
  [nextLabel]="'common_next' | translate"
  [previousLabel]="'common_back' | translate"
  [maxSize]="maxSize"
  [responsive]="responsive"
  (pageChange)="pageChange.emit($event)"
></pagination-controls>